import makeStyles from '@mui/styles/makeStyles';

const usePrgraphStyles = makeStyles({
  root: {
    "& MuiPickersDay-daySelected": {
      backgroundColor: "white",
      boxShadow: "4px 4px 15px rgba(0, 0, 0, 0.05)",
      borderRadius: "50px",
      border: "none",
      "&:hover": {
        backgroundColor: "white",
        border: "none",
      },
    },

    "& .MuiInputBase-root": {
      color: "#000",
      // backgroundColor: "transparent",
      borderRadius: "50px",
      border: "none",
      fontSize: '12px',
      justifyContent:'center'
    },
    "& MuiPickersDay-daySelected": {
      backgroundColor: "white",
      border: "none",
      "&:hover": {
        backgroundColor: "white",
        border: "none",
      },
    },
    "& .MuiFormLabel-root":{
      backgroundColor: "#fff",
      padding: "0px 6px 0px 6px",
      borderRadius:"10px"
    },
  },
  datePicker: {
    color: "#000",
    backgroundColor: "white",
    border: "none",
    boxShadow: "1px 4px 15px rgba(0, 0, 0, 0.05)",

    "& .MuiOutlinedInput-root": {
      border: "none",
      height: "40px",
      width: "130px",
    },
    "& .MuiOutlinedInput-input": {
      border: "none",
      padding: "5px",
    },
  },
});

export default usePrgraphStyles;
